import React from 'react';
import { IonAlert, IonBackButton, IonButtons, IonCard, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonToast, IonToolbar, withIonLifeCycle } from '@ionic/react';

//	L O C A L E

import { locale___App } from '../../../App.locale';
import { locale___SbDigitalMenuEditDishesPage } from './sb-digitalmenu-edit-dishes.locale';

//	I N T E R F A C E S

import { interface___IonAlert } from '../../../interfaces/interface.alert';

//	S T Y L E

import './sb-digitalmenu-edit-dishes.scss';

//	S T A T E   -   P R O P S

import { props___SbDigitalMenuEditDishesPage, state___SbDigitalMenuEditDishesPage, state___SbDigitalMenuEditDishesPage___default } from './sb-digitalmenu-edit-dishes.state';

//	T Y P E S

import { type___api___response } from '../../../types/types.api-response';

//	S E R V I C E S

import { service_RestApiService } from '../../../services/service-api';
import { service_Router } from '../../../services/service-router';
import { service_LocalizationService } from '../../../services/service-localization';

//	C O M P O N E N T S

import Com404Component from '../../../components/com-404/com-404';
import ComDigitalMenuDishComponent from '../../../components/com-digitalmenu-dish/com-digitalmenu-dish';
import ComSpinnerInlineComponent from '../../../components/com-spinner-inline/com-spinner-inline';

//	M O D A L S

import MdDishEditModal from '../../../modals/md-dish-edit/md-dish-edit';

//	C L A S S

class SbDigitalMenuEditDishesPage extends React.Component<props___SbDigitalMenuEditDishesPage, state___SbDigitalMenuEditDishesPage> {

//#region 																							D E C L A R A T I O N S

	private readonly _API: service_RestApiService = new service_RestApiService();
	private readonly _ROUTER: service_Router = new service_Router();
	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

//#endregion

//#region 																							C O N F I G

	private readonly ionAlert___askForDeleteDish___config: interface___IonAlert = {
		header: 'Conferma eliminazione',
		message: 'Sei sicuro di voler eliminare permanentemente questo piatto?',
		buttons: [{
			text: this._LOCALE.translate(locale___App.ionAlert___button___yes),
			handler: () => {
				this.setState({
					digitalmenu___props___isLoading: true,
				}, async () => {
					const ___dish_is___deleted: type___api___response = await this._API.dishes___delete(this.state.digitalmenu___id, this.state.ionAlert___askForDeleteDish___argument['dish_id']);
					this.setState({
						ionToast___dishDeleted___isVisible: (___dish_is___deleted && ___dish_is___deleted.response === 'success') ? true : false,
					}, async () => {
						await this.read_props___digitalmenu();
					});
				});
			}
		}, {
			text: this._LOCALE.translate(locale___App.ionAlert___button___cancel),
			role: 'cancel',
			handler: () => {
				this.setState({ ionAlert___askForDeleteDish___isOpen: false });
			}
		}]
	};

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___SbDigitalMenuEditDishesPage,
	) {
		super(props);
		this.state = state___SbDigitalMenuEditDishesPage___default;
	}

//#endregion

//#region 																							R E A D   P R O P S

	private read_props___digitalmenu = async () => {
		const ___temp___poi___props: type___api___response = await this._API.digitalmenus___read_single(this.state.digitalmenu___id);
		if (!___temp___poi___props || ___temp___poi___props.response !== 'success' || ___temp___poi___props.data === null) { console.log('404'); }
		this.setState({
			digitalmenu___props: ___temp___poi___props.data,
			digitalmenu___props___isLoading: false,
		});
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___dish_edit = (___dish_id: string | null, ___dish_category: string | null) => {
		this.setState({
			ionModal___MdDishEditModal___isOpen: true,
			ionModal___MdDishEditModal___target_id: ___dish_id,
			ionModal___MdDishEditModal___target_category: ___dish_category,
		});
	}

	private handle___dish___change_active_state = async (___dish_id: string, ___new_active_state: boolean) => {

		console.log('___dish_id', ___dish_id)
		console.log('___new_active_state', ___new_active_state)

		const ___temp___active_dish: type___api___response = await this._API.dishes___activate(this.state.digitalmenu___id, ___dish_id, ___new_active_state);








	}

//#endregion

//#region 																							L I F E C Y C L E

	ionViewDidEnter() : void {
		const ___digitalmenu_id: string | null = this._ROUTER.get_id(this.props);
		this.setState({
			digitalmenu___id: ___digitalmenu_id,
		}, async () => {
			await this.read_props___digitalmenu();
		});
	}

//#endregion

//#region 																							R E T U R N

	render() : React.ReactNode {
		return <>
			<IonPage>

				<IonAlert isOpen={ this.state.ionAlert___askForDeleteDish___isOpen } {...this.ionAlert___askForDeleteDish___config}></IonAlert>
				<IonToast isOpen={ this.state.ionToast___dishDeleted___isVisible } message={ this._LOCALE.translate(locale___SbDigitalMenuEditDishesPage.toast___dishDeleted) } duration={ 3000 } position="top" onDidDismiss={() => { this.setState({ ionToast___dishDeleted___isVisible: false }); }} color="danger" />

				<MdDishEditModal isOpen={ this.state.ionModal___MdDishEditModal___isOpen } dish_digitalmenu={ this.state.digitalmenu___id } dish_id={ this.state.ionModal___MdDishEditModal___target_id } dish_category={ this.state.ionModal___MdDishEditModal___target_category } event___onDidDismiss={() => { this.setState({ ionModal___MdDishEditModal___isOpen: false, ionModal___MdDishEditModal___target_id: null, ionModal___MdDishEditModal___target_category: null }, () => { this.read_props___digitalmenu(); }); }}></MdDishEditModal>

				<IonHeader>
					<IonToolbar>
						<IonButtons slot="start">
							<IonBackButton defaultHref="/dashboard" text={ this._LOCALE.translate(locale___App.ionBackButton___text) }></IonBackButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<IonContent forceOverscroll={ false }>

					{(this.state.digitalmenu___props___isLoading === true) ? <>

						<br />
						<br />
						<br />
						<br />
						<br />
						<br />

						<ComSpinnerInlineComponent />

					</> : <>

						{(this.state.digitalmenu___props !== null) ? <>

							<section className="sb-digitalmenu-view---container">
								
								<h1>{ this.state.digitalmenu___props['digitalmenu_name'] }</h1>

								<br />

								<IonCard>
									<IonList>
										<IonItem className="is-ion-item-button" button={ true } onClick={() => { this.handle___dish_edit(null, null); }}>
											<i className="fas fa-plus"></i>
											<IonLabel><b>Aggiungi Piatto/Prodotto</b></IonLabel>
										</IonItem>
									</IonList>
								</IonCard>
								
								<br />

								{this.state.digitalmenu___props['digitalmenu_contents'].map((___d_c: any, ___d_c___idx: number) => { return <>
									{(___d_c['dish_category_contents'].length > 0) ? <>
										<IonCard key={ ___d_c___idx } className="sb-digitalmenu-view---card">
											<IonItem className="sb-digitalmenu-view---card---title">
												<div>
													<img src={ '/assets/digitalmenu/categories/' + ___d_c['dish_category_icon'] + '.svg' } />
													<h6>{ ___d_c['dish_category_name'] }</h6>
												</div>
											</IonItem>
											<IonList>
												{___d_c['dish_category_contents'].map((___dish: any, ___dish___idx: number) => {
													return <>
														<ComDigitalMenuDishComponent key={ ___dish___idx } dish_props={ ___dish } dish_icon={ ___dish['dish_category_icon'] } event___onClick={(___dish_id: string) => { this.handle___dish_edit(___dish_id, ___d_c['dish_category_id']); }} event___onVisibilityChange={(___new_active_state: boolean) => { this.handle___dish___change_active_state(___dish['dish_id'], ___new_active_state); }} event___onDelete={() => { this.setState({ ionAlert___askForDeleteDish___argument: ___dish, ionAlert___askForDeleteDish___isOpen: true}); }}/>
													</>;
												})}
											</IonList>
										</IonCard>
										<br />
									</> : <></>}
								</>;})}

							</section>

						</> : <>

							<Com404Component/>

						</>}

						<br />
						<br />
						<br />

					</>}
				</IonContent>

			</IonPage>
		</>;
	}

//#endregion

}

//	E X P O R T

export default withIonLifeCycle(SbDigitalMenuEditDishesPage);